<div>
    <h2>Command File Content</h2>
    <pre *ngIf="fileContentXML != null"
         [innerHTML]="fileContentXML"
         style="max-height:600px; overflow:auto; background:#fafafa; border:1px solid #ccc; padding:12px;">
    </pre>
    <button mat-raised-button color="primary" (click)="downloadContent()" [disabled]="!fileContent">
        Download
    </button>
</div>
